module.exports = __webpack_public_path__ + "img/key-testnet.3bb2834f.png";